import { Chip, Tooltip, Typography } from '../../../../stories/atoms';
import { RowFlexContainer } from '../../../../stories/atoms/containerV2/ContainerV2';

export type ChipDefinition<T extends string> = {
  key: T;
  label: string;
  tooltip?: string;
};

type ToggleChipGroupProps<T extends string> = {
  chipOptions: ChipDefinition<T>[];
  selectedChip: T;
  setSelectedChip: (chip: T) => void;
};

export const ToggleChipGroup = <T extends string>({
  chipOptions,
  selectedChip,
  setSelectedChip,
}: ToggleChipGroupProps<T>) => {
  return (
    <RowFlexContainer margin={[2, 0, 2]} gap={[2]} overflow="auto">
      {chipOptions.map((chip) => (
        <Tooltip
          text={
            <Typography padding={[1]} color="white">
              {chip.tooltip}
            </Typography>
          }
          position="bottom"
          key={`tooltip-${chip.key}`}
          isVisible={!!chip.tooltip}
        >
          <div>
            <Chip
              key={chip.key}
              label={chip.label}
              isSelected={selectedChip === chip.key}
              color="default"
              variant={selectedChip === chip.key ? 'filled' : 'outlined'}
              size="small"
              onClick={() => {
                setSelectedChip(chip.key);
              }}
              borderRadius="4px"
            />
          </div>
        </Tooltip>
      ))}
    </RowFlexContainer>
  );
};
